import { FC, useState } from 'react'
import { SequenceMenu } from '@sequencehq/core-components'
import { MarkAsSentCreditNoteDialog } from 'CreditNotes/components/dialog/MarkAsSentCreditNoteDialog'

type Props = {
  creditNoteId: string
}

export const MarkAsSentCreditNoteMenuItem: FC<Props> = ({ creditNoteId }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <SequenceMenu.Item
        uuid="mark-as-sent-credit-note"
        data-testid={`creditNotes.${creditNoteId}.menuItem.markAsSent`}
        label="Mark credit note as sent"
        onClick={e => {
          e.stopPropagation()
          setShowModal(true)
        }}
      />
      {showModal && (
        <MarkAsSentCreditNoteDialog
          creditNoteId={creditNoteId}
          isOpen
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  )
}
